import React from 'react'
import styled from 'styled-components'
import { mixinSmallBadge } from 'spa/member/styles/mixin'

export type Props = {
  htmlFor: string,
  label: string | React.ReactNode,
  noBadge?: boolean,
  required: boolean,
  annotationNote?: string,
} & React.HTMLAttributes<HTMLLabelElement>

const StyledLabelContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
`

const StyledLabel = styled.label`
  color: ${props => props.theme.members.colors.black._100};
  font-size: .875rem;
  font-weight: 700;
  line-height: 23.8px;
  margin: 0;
`

const StyledBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  height: 1.5rem;
`

const StyledRequiredBadge = styled.span<{ required: boolean }>`
  ${mixinSmallBadge}
`;

const StyledOptionalBadge = styled.span`
  ${mixinSmallBadge}
  color: ${props => props.theme.members.colors.silver._100};
  border: 1px solid ${props => props.theme.members.colors.silver._100};
`;

const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledAnnotationNote = styled.span`
  font-size: .75rem;
  font-weight: 400;
  line-height: 1.7;
  text-align: left;
`

export const StyledQuestionnaireFormLabel: React.FC<Props> = (props: Props) => {
  return (
    <StyledLabelContainer>
      {!props.noBadge && (
        props.required ? (
          <StyledBadgeContainer>
            <StyledRequiredBadge>必須</StyledRequiredBadge>
          </StyledBadgeContainer>
        ) : (
          <StyledBadgeContainer>
            <StyledOptionalBadge>任意</StyledOptionalBadge>
          </StyledBadgeContainer>
        )
      )}
      <StyledTextContainer>
        <StyledLabel>{props.label}</StyledLabel>
        {props.annotationNote && <StyledAnnotationNote>{props.annotationNote}</StyledAnnotationNote>}
      </StyledTextContainer>
    </StyledLabelContainer>
  )
}
